export default __webpack_public_path__ + "static/tiger-fans-video-f3128c07094dab9d1b177a3f021b1564.webp";